export default "__VITE_ASSET__BMNcTZOz__"